import { Collapse, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { CollapseProps } from "antd";
import { getCurrentSeason } from "@common/season";

const { Title, Paragraph } = Typography;

export const FAQPage = () => {
  const season = getCurrentSeason();
  const faqItems: CollapseProps["items"] = [
    {
      key: "1",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">WHAT TIME WILL MY DRIVEWAY BE PLOWED?</span>,
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          Estabrook, Inc. will be clearing less driveways per tractor than typical, meaning more time to spend on your driveway. We have a fleet of more than 16 New Holland Tractors that are operated by trained operators. Our employees are almost entirely local Truckee residents.
        </Paragraph>
      ),
    },
    {
      key: "2",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">HOW DO I KNOW THIS NEW SERVICE WILL PERFORM?</span>, 
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          Our operators undergo rigorous training and certification programs. We maintain high standards for performance and customer satisfaction. All operators are background-checked and have extensive experience in snow removal operations in the Tahoe area.
        </Paragraph>
      ),
    },
    {
      key: "3",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">WILL YOU CLEAR MY WALKWAYS AND DECKS?</span>,
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          Our standard service includes driveway clearing. Walkway and deck clearing services are available as an add-on service. Please contact us for pricing and to add these services to your snow removal contract.
        </Paragraph>
      ),
    },
    {
      key: "4",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">WHAT WILL THIS SERVICE COST ME?</span>,
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          Pricing varies based on the size of your driveway, location, and additional services requested. We offer competitive seasonal contracts. Please submit your information through our sign-up form to receive a personalized quote for the {season} season.
        </Paragraph>
      ),
    },
    {
      key: "5",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">WHAT IF THERE ARE OBSTACLES LIKE CARS IN MY DRIVEAWAY?</span>,
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          We ask that all vehicles be moved from the driveway area before our scheduled service. If obstacles prevent us from clearing your driveway, we will make note of it and attempt to return later if possible. Clear driveways ensure the best and most efficient service.
        </Paragraph>
      ),
    },
    {
      key: "6",
      label: <span className="font-azonix !font-normal text-base md:text-lg text-dark">HOW CLOSE TO MY GARAGE AND STEPS WILL THE OPERATOR GET?</span>,
      children: (
        <Paragraph className="text-white text-justify tracking-wider">
          Our operators are trained to clear as close to structures as safely possible, typically within 6-12 inches of garage doors and steps. For safety reasons and to prevent property damage, some hand clearing may be necessary for the final few inches.
        </Paragraph>
      ),
    },
  ];

  const customExpandIcon = ({ isActive }: { isActive?: boolean }) => (
    <DownOutlined
      rotate={isActive ? 180 : 0}
      className="text-white !text-xl transition-transform"
    />
  );

  return (
    <div
      className="w-full pb-10 md:pb-20"
      style={{
        backgroundImage: "url('/assets/images/background-darker.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Hero Section */}
      <section className="w-full h-[400px]">
        <div className="container h-full flex flex-col justify-center items-center mx-auto">
          <Title
            level={1}
            className="font-azonix !font-normal text-primary text-center tracking-wider mb-4"
          >
            FREQUENTLY ASKED QUESTIONS
          </Title>
          <div className="max-w-3xl mx-auto">
            <Paragraph className="text-center text-lg text-light">
            Learn everything you want to know about Estabrook Inc. Snow Removal services in Tahoe Donner. If you have any questions don't hesitate to call us at
            {" "}
              <a href="tel:8889585509" className="text-light">
                (888) 958 5509
              </a>
              .
            </Paragraph>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Collapse
              ghost
              className="faq-collapse"
              items={faqItems}
              accordion
              expandIcon={customExpandIcon}
            />
          </div>
        </div>
      </section>
    </div>
  );
};